import * as React from 'react'
import axios from 'axios'
import {HOST} from "./Utilities";

// const HOST = 'http://centos7.top:8080/api/'; //'https://ekarty.merkurymarket.pl/api/'; //'http://centos7.top:8080/api/'

export default {

    Register(data: any) {
        return axios.request({
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            url: HOST()+'/esklep/mobile/user/registerUser',
            data: data
        })
    },

    Migracja(data: any, typMigracji: string) {
        return axios.request({
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            url: HOST()+`/esklep/mobile/user/registerUser?migration=${typMigracji}`,
            data: data
        })
    },

    SprawdzHaslo(haslo: string) {
        return axios.request({
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            url: HOST()+'/esklep/mobile/user/checkPassword',
            // url: HOST()+'/api/register/checkPassword',
            data: {
                'password': haslo
            }
        })
    },

    Aktywacja(email: string, token: string) {
        return axios.request({
            method: 'post',
            url: HOST()+`/esklep/mobile/user/activateEmail`,
            data: {
                'email': atob(email),
                'token': token
            }
        })
    },

    AktywacjaV2(email: string, token: string) {
        return axios.request({
            method: 'post',
            url: `https://esklep.merkurymarket.pl/esklep/mobile/user/activateEmail`,
            data: {
                'email': atob(email),
                'token': token
            }
        })
    },

    ResetHasla(login: string) {
        return axios.request({
            method: 'put',
            headers: {'Content-Type': 'application/json'},
            // url: HOST()+'register/resetHasla',
            url: HOST()+'/esklep/mobile/user/resetPassword',
            data: {
                'login': login
            }
        })
    },

    ZmianaHaslaReset(login: string, token: string, haslo: string) {
        return axios.request({
            method: 'put',
            // url: HOST()+'register/ustawNoweHaslo',
            url: HOST()+'/esklep/mobile/user/setNewPassword',
            data: {
                'login': atob(login),
                'newPassword': haslo,
                'token': token
            }
        })
    },

    ZmianaHaslaResetOld(token: string, haslo: string) {
        return axios.request({
            method: 'post',
            url: HOST()+'/api/register/ustawNoweHaslo',
            data: {
                'newPassword': haslo,
                'token': token
            }
        })
    },

    ZmianaHaslaResetNew(login: string, token: string, haslo: string) {
        return axios.request({
            method: 'put',
            // url: HOST()+'register/ustawNoweHaslo',
            url: 'https://esklep.merkurymarket.pl/esklep/mobile/user/setNewPassword',
            data: {
                'login': atob(login),
                'newPassword': haslo,
                'token': token
            }
        })
    },

    ZmianaHasla(data: any) {
        return axios.request({
            method: 'put',
            url: HOST()+'/esklep/mobile/user/changePassword',
            // url: HOST()+'klient/zmianaHasla',
            data: data
        })
    },

    UsunKontoKlienta(data: any) {
        return axios.request({
            method: 'put',
            url: HOST()+'/esklep/mobile/user/prepareDeleteAccount',
            // url: HOST()+'klient/zmianaHasla',
            data: data
        })
    },

    ConfirmUsunKontoKlienta(token: any, login: any) {
        return axios.request({
            method: 'put',
            url: HOST()+`/esklep/mobile/user/confirmDeleteAccount?token=${token}&login=${atob(login)}`,
            // url: HOST()+'klient/zmianaHasla',
            // data: data
        })
    },

    Zaloguj(login: string, pass: string) {
        return axios.request({
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            url: HOST()+'/esklep/mobile/user/login',
            // url: HOST()+'login',
            data: {
                "haslo": pass,
                "login": login,
                "numerImei": 'web',
                "kraj": 'PL'
            }
        })
    },

    getKlient(email: string) {
        return axios.request({
            method: 'post',
            url: HOST()+`/esklep/mobile/user/getUserData`,
            // url: HOST()+`klient/${id}`
            data: {
                login: email
            }
        })

        // return axios.request({
        //     method: 'post',
        //     url: HOST()+`/esklep/mobile/user/getUser`,
        //     // url: HOST()+`klient/${id}`
        //     data: {
        //         login: email
        //     }
        // })

        // return axios.request({
        //     method: 'get',
        //     url: HOST()+`klient/${id}`
        // })
    },

    getKlientKarty() {
        return axios.request({
            method: 'get',
            // url: HOST()+`/esklep/mobile/user/getUserData`,
            url: HOST()+`/api/klient/kartyAndUpust`,
            // data: {
            //     login: email
            // }
        })
    },

    WeryfikujNip(kraj: string, nip: string) {
        return axios.request({
            method: 'get',
            url: HOST()+`/esklep/mobile/user/validateTaxId/${kraj}/${nip}`
        })
    },

    getOddzialy() {
        return axios.request({
            method: 'get',
            url: HOST()+'/esklep/mobile/oddzialy?kraj=PL'
            // url: HOST()+'klient/kasa/klientDaneKasy'
        })
    },

    getKrajeFirma() {
        return axios.request({
            method: 'get',
            url: HOST()+'/esklep/mobile/user/getCountries'
            // url: HOST()+'register/oddzialy?kraj=PL'
        })
    },

    getOddzialyRegister() {
        return axios.request({
            method: 'get',
            url: HOST()+'/esklep/mobile/oddzialy?kraj=PL'
            // url: HOST()+'/api/register/oddzialy?kraj=PL'
        })
    },

    weryfikujLogin(login: any) {
        return axios.request({
            method: 'get',
            url: HOST()+`/esklep/mobile/user/checkLogin?login=${login}`
        })
    },

    // putKlientSklep(id: number, kraj: string, numag: number) {
    //     return axios.request({
    //         method: 'put',
    //         url: HOST()+`klient/kontrahent/${id}/sklep`,
    //         data: {
    //             'kraj': kraj,
    //             'numag': numag
    //         }
    //     })
    // },

    ustawSklepKlienta(numag: number) {
        return axios.request({
            method: 'put',
            url: HOST()+`/esklep/mobile/user/setMagazyn?numag=${numag}`
        })
    },

    // aktualizujDane(id: number, data: any) {
    aktualizujDane(data: any) {
        return axios.request({
            method: 'put',
            url: HOST()+`/esklep/mobile/user/setUserData`,
            // url: HOST()+`klient/kontrahent/${id}`,
            data: data
        })
    },

    getTrescHtml(typ: any, kraj: any) {
        return axios.request({
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            url: HOST()+`/esklep/mobile/cms/getWpisyCms`,
            data: {
                typ: typ,
                kraj: kraj
            }
        })
    },

    getDaneDoMigracji(typ: string, login: string, pass: string) {
        return axios.request({
            method: 'post',
            url: HOST()+`/esklep/mobile/user/${typ}`,
            data: {
                "haslo": pass,
                "login": login,
                "numerImei": 'web',
                "kraj": 'PL'
            }
        })
    },

    wyslijLinkAktywacyjny(email: string) {
        return axios.request({
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            url: HOST()+`/esklep/mobile/user/resendActivationEmail`,
            data: email
        })
    },

}
